/**
 * stores/info-hint-flash.ts — Zustand store for triggering pulse on all InfoHint components.
 *
 * Used to implement the "Take a tour" flash behavior — increments the counter,
 * which triggers a 2s pulse animation on all subscribed InfoHint instances.
 */

import { create } from 'zustand';

interface InfoHintFlashStore {
  counter: number;
  flashAll: () => void;
}

export const useInfoHintFlash = create<InfoHintFlashStore>((set) => ({
  counter: 0,
  flashAll: () => set((s) => ({ counter: s.counter + 1 })),
}));
